<template>
	<div class="transactions-view">
		<div class="transactions-empty" v-if="this.hasAccounts == 0">
			<roundups-tile />
		</div>
		<div v-else>
			<template slot="header">
				<ui-header type="dark" @click="onBack">
					<h2 slot="title">Transactions</h2>
				</ui-header>
			</template>
			<div class="transactions-list" ref="transactionList">
				<div
					class="date-group"
					v-for="group in grouped"
					:key="group.date"
				>
					<span class="date-group-header">{{ group.date }}</span>
					<li
						class="transaction-item"
						v-for="item in group.items"
						:key="item.id"
					>
						<div class="item-text">
							<span class="item-name"
								>${{ item.amount.toFixed(2) }}
								{{ item.name }}</span
							>
							<span class="item-account"
								>{{ item.account.name }}
								{{ item.account.mask }}</span
							>
							<span
								@click="viewInfo()"
								v-if="item.amount % 1 == 0"
								class="info"
								>What are Whole Dollar Roundups?</span
							>
						</div>
						<span class="item-roundup"
							>+${{ item.roundUp.toFixed(2) }}</span
						>
					</li>
				</div>
				<div
					class="transactions-empty"
					v-if="transactions.length <= 0 && this.hasAccounts > 0"
				>
					<h3>No Transactions</h3>
					<p>
						Looks like no transactions have loaded yet. Sometimes it
						takes a few minutes for it all to load. Want to check
						again?
					</p>
					<ui-button @click="reloadPage" :loading="isLoading"
						>Reload</ui-button
					>
				</div>
			</div>

			<notification></notification>
			<modal v-model="showWholeDollar">
				<h3>What are Whole Dollar Roundups?</h3>
				<p>
					To maximize your impact for your organization, we round
					Whole Dollar Transactions (ie $1.00, $2.00, etc) to the next
					dollar. So a $4 transaction becomes $5. If you would like to
					change the amount of your Whole Dollar Roundup, please do so
					in your Settings.
				</p>
				<ui-button
					@click="navigate({ name: 'settings.cap' }, 'up')"
					:loading="isLoading"
					>Go to settings</ui-button
				>
			</modal>
		</div>
	</div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import UiButton from '../../../ui/Button'
import UiHeader from '../../../ui/Header'
import Notification from '../../../ui/Notification'
import Modal from '../../../ui/Modal'
import RoundupsTile from '../RoundupsTile'

export default {
	name: 'transactions-view',
	components: { UiButton, UiHeader, Notification, Modal, RoundupsTile },
	data() {
		return {
			isLoading: false,
			showWholeDollar: false
		}
	},
	computed: {
		...mapState({
			graph: ({ transactionList }) => transactionList.graph
		}),
		...mapGetters([
			'maxDonation',
			'transactions',
			'totals',
			'grouped',
			'notifications',
			'hasAccounts'
		]),
		nextDonation() {
			if (this.maxDonation) {
				if (this.totals.next * 100 > this.maxDonation) {
					return this.maxDonation / 100
				}
			}
			return this.totals.next
		},
		overCap() {
			if (this.maxDonation) {
				return this.totals.next * 100 > this.maxDonation
			}
			return false
		}
	},
	methods: {
		...mapActions(['getTransactions', 'getNotifications']),
		reloadPage() {
			this.isLoading = true
			this.getTransactions().then(() => {
				this.isLoading = false
			})
		},
		onBack() {
			this.navigate({ name: 'home' }, 'back')
		},
		viewInfo() {
			this.showWholeDollar = true
		}
	},
	mounted() {
		this.getTransactions()
		this.getNotifications()
	}
}
</script>

<style lang="scss">
.transactions-view {
	overflow: visible;
	&.slide-left-leave-active {
		.transactions-list {
			display: none;
		}
	}
	.transactions-list {
		background: $white;
		margin: 10px -25px 0px;
		position: relative;
		padding: 10px 20px 20px;
		z-index: 10;
		border-radius: 14px;
		box-shadow: 0px 3px 30px rgba(0, 0, 0, 0.15);
		@media screen and (max-width: 480px) {
			margin-left: -15px;
			margin-right: -15px;
		}
		.date-group {
			.date-group-header {
				background: $light-grey;
				font-size: 14px;
				display: block;
				padding: 10px 0;
				margin: 10px 0;
				font-weight: 900;
				color: $dark-grey;
				border-bottom: 1px solid $light-grey;
				text-align: center;
				border-radius: 25px;
			}
		}
		.transaction-item {
			border-bottom: 1px solid $light-grey;
			padding: 10px 0;
			margin: 0 10px;
			text-align: left;
			list-style: none;
			display: flex;
			align-items: center;
			justify-content: center;
			&:last-child {
				border-bottom: 0px;
			}
			.item-roundup {
				flex-shrink: 0;
				flex-grow: 0;
				color: $navy;
				font-weight: bold;
			}
			.item-text {
				flex-grow: 1;
				.item-name {
					font-weight: 600;
					color: $dark-grey;
					font-size: 16px;
				}
				.item-account {
					font-size: 14px;
					color: $dark-grey;
					opacity: 0.5;
				}
				.info {
					font-size: 14px;
					color: $dark-grey;
					opacity: 0.5;
					text-decoration: underline;
					cursor: pointer;
					&:hover {
						opacity: 1;
					}
				}
			}
			span {
				display: block;
			}
		}
		.transactions-empty {
			padding: 20px 40px;
			color: $blue;
			text-align: center;
			h3 {
				font-size: 24px;
			}
			button {
				margin-top: 10px;
			}
		}
	}
}
</style>
